import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, FormControl, ValidatorFn, Validators } from '@angular/forms';

@Component({
    selector: 'dialog-timerequest-component',
    styleUrls: ['timerequest.dialogcomponent.scss'],
    templateUrl: 'timerequest.dialogcomponent.html',
})
export class TimeRequestDialogComponent implements OnInit {
    title: string;
    message: string;
    inputhint: string;
    inputprefix: string;
    oktext: string;
    canceltext: string;
    placeholderText: string; // TODO!
    showIcon: boolean; // TODO!
    textboxprefix: string;
    timeeditable: boolean;
    validators: ValidatorFn[];
    value: number;

    inputForm: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<TimeRequestDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseTimeRequestDialogOptions,
        private fb: FormBuilder
    ) {
        this.title = data.TitleText || 'Request Time Approval';
        this.message = data.MessageText || '';
        this.inputprefix = data.InputPrefix || '';
        this.inputhint = data.InputHint || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.timeeditable = data.TimeEditable != null ? data.TimeEditable : true;
        this.validators = data.Validators || null;
        this.value = data.Value != null ? data.Value : null;
        this.textboxprefix = data.TextboxPrefix || '';
    }

    ngOnInit() {
        // Set up the form group
        this.inputForm = this.fb.group({
            JobTime: [this.value],
            OptionalComment: [''],
        });

        // If we were provided validators, set them now.
        if (this.validators && this.validators.length > 0) {
            const ctrl = this.inputForm.get('JobTime');
            const toSet = [Validators.required, ...this.validators];

            ctrl.setValidators(toSet);
            this.inputForm.updateValueAndValidity();
        }
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    OKHandler() {
        const response = <BaseTimeRequestResult>this.inputForm.getRawValue();

        this.dialogRef.close(response);
    }
}

// #region Custom Classes

export class BaseTimeRequestDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    InputPrefix?: string;
    InputHint?: string;
    Validators?: ValidatorFn[];
    Value?: number;
    TextboxPrefix?: string;
    TimeEditable?: boolean;
}

// #region Base Time Request Result Class

export class BaseTimeRequestResult {
    JobTime?: number;
    OptionalComment?: string;
}

// #endregion

// #endregion
